import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    empty: 'You have no active claims',
    claim: 'Claim',
  },
};
